// extracted by mini-css-extract-plugin
module.exports = {"base":"CTAButton_base__pj4M6","desktop":"CTAButton_desktop__HzqTw","mobile":"CTAButton_mobile__UiHgA"};